<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>

    <b-row class="match-height mt-1 mb-4">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <Alert
          :show="showFormErrorAlert"
          :message="$t('Card Request Type or Customer\'s account number is required')"
        />
        <b-row>
          <b-col md="12">
            <SelectField
              id="card-request-type"
              v-model="searchParams.requestType"
              :label="$t('Card Request Type')"
              :options="translatedCardRequestTypeOptions"
              :reduce="option => option.value"
              :placeholder="$t('Select')"
              item="label"
              :set-selected="setCardRequestType"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="number"
            />
          </b-col>
        </b-row>

        <Button
          :label="$t('Search')"
          size="md"
          class="mt-2"
          block
          @click="handleSearch"
        />
      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton ? '12' : '8'"
      >
        <div
          class="mt-3"
        >
          <validation-observer ref="issueCardRules">
            <b-form @submit.prevent="handleSubmit">
              <b-row class="match-height">
                <b-col
                  v-if="isAssignedCard"
                  md="3"
                >
                  <InputField
                    id="account-number"
                    v-model="issueCardFormData.batchRequestId"
                    :label="$t('Batch Request Id')"
                    type="text"
                    readonly
                  />
                </b-col>
                <!-- Account Number -->
                <b-col md="3">
                  <InputField
                    id="account-number"
                    v-model="issueCardFormData.accountNumber"
                    :label="$t('Account Number')"
                    type="text"
                    readonly
                  />
                </b-col>

                <!-- Account Name -->
                <b-col md="3">
                  <InputField
                    id="account-name"
                    v-model="issueCardFormData.accountName"
                    :label="$t('Account Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <!--  Account Number -->

                <!-- Product Name -->
                <b-col md="3">
                  <InputField
                    id="product-name"
                    v-model="issueCardFormData.productName"
                    :label="$t('Product Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <!-- Product Name -->

                <!-- Available Balance -->
                <b-col
                  v-if="!isAssignedCard"
                  md="3"
                >
                  <InputField
                    id="available-balance"
                    v-model="issueCardFormData.availableBalance"
                    :label="$t('Available Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
                <!-- Available Balance -->
              </b-row>

              <b-row class="match-height">
                <!--  Select From A List Of Batches -->
                <b-col
                  v-if="!isAssignedCard"
                  md="3"
                >
                  <SelectField
                    id="batch-list"
                    v-model="issueCardFormData.cardGenerationRequestId"
                    :label="$t('Select From A List Of Batches')"
                    :options="batchRequestOptions"
                    :reduce="option => option.value"
                    :placeholder="$t('Select')"
                    :error-name="$t('Select From A List Of Batches')"
                    rules="required"
                    item="label"
                    :readonly="isReadonly"
                    :set-selected="setBatchRequestId"
                  />
                </b-col>
                <!--  Select From A List Of Batches -->

              </b-row>

              <b-row>
                <b-col md="2">
                  <Button
                    v-if="actionType !== 'view'"
                    :label="$t('Next')"
                    variant="primary"
                    size="md"
                    class="mt-3"
                    @click="onViewPassportAndSignature"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal"
      centered
      size="lg"
      :title="$t('Search Result')"
      ok-only
      :ok-title="$t('Cancel')"
      ok-variant="outline-secondary"
    >
      <b-table
        ref="customerListTable"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        show-empty
        selectable
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

        <template #cell(accountStatus)="data">
          <b-badge
            pill
            :variant="getStatusColor(data.value)"
          >
            {{ data.value }}
          </b-badge>
        </template>
      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="search-modal-assigned"
      ref="search-modal-assigned"
      centered
      size="lg"
      :title="$t('Search Result')"
      ok-only
      :ok-title="$t('Cancel')"
      ok-variant="outline-secondary"
    >
      <b-table
        ref="customerListTable"
        :items="customerList"
        responsive
        :fields="tableHeadersAssigned"
        primary-key="id"
        show-empty
        selectable
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

        <template #cell(accountStatus)="data">
          <b-badge
            pill
            :variant="getStatusColor(data.value)"
          >
            {{ data.value }}
          </b-badge>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <template>
              <Button
                :label="$t('Continue')"
                variant="primary"
                :disabled="data.item.cardStatus === 'Generated' && data.item.issuanceStatus === 'NotIssued' ? false : true"
                size="sm"
                class="mt-0"
                @click="onSelectCustomerAssigned(data.item)"
              />
            </template>
          </div>
        </template>
      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="signatory-mandate-table"
      ref="signatoryMandateTable"
      no-close-on-backdrop
      ok-variant="outline-secondary"
      :ok-title="$t('Cancel')"
      ok-only
      centered
      size="lg"
      :title="$t('Passport and Signature')"
    >
      <b-table
        ref="signatoryTable"
        select-mode="single"
        :items="signatoryList"
        responsive
        no-local-sorting
        :fields="translatedSignatoryListHeader"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

        <template #cell(select)="data">

          <b-form-group class="mt-1">
            <b-form-checkbox
              v-model="data.item.select"
              @change="onSelect"
            />
          </b-form-group>
        </template>

        <template #cell(passport)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.passport"
                button
                @click="onViewPassport(data.item.passport, data.item.fullName)"
              />
            </template>
          </b-media>
        </template>

        <template #cell(signature)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.signature"
                button
                @click="onViewSignature(data.item.signature, data.item.fullName)"
              />
            </template>
          </b-media>
        </template>
      </b-table>
      <div
        v-if="!isAssignedCard"
        class="text-center mt-1"
      >
        <Button
          :label="$t('Next')"
          variant="primary"
          size="lg"
          class="mt-3"
          :disabled="isDisabledViewList"
          @click="fetchCardLists"
        />
      </div>
      <div
        v-if="isAssignedCard"
        class="text-center mt-1"
      >
        <Button
          :label="$t('Issue Card')"
          :loading="isLoading"
          :disabled="isDisabledIssuedCard"
          variant="primary"
          size="lg"
          @click="handleSubmit"
        />
      </div>
    </b-modal>

    <b-modal
      id="unassigned-view-list-modal"
      ref="unassignedViewListTable"
      no-close-on-backdrop
      ok-variant="outline-secondary"
      :ok-title="$t('Cancel')"
      centered
      size="lg"
      :title="$t('View Card List')"
    >
      <div class="mb-2 mt-1 d-flex align-items-center">
        <TableEntries
          v-model="cardPerPage"
          :options="perPageOptions"
        />
      </div>

      <b-table
        ref="viewCardListRef"
        :busy="isBusy"
        :per-page="cardPerPage"
        :current-page="cardCurrentPage"
        :items="viewCardLists"
        responsive
        :fields="translatedViewCardListHeader"
        primary-key="id"
        show-empty
        :empty-text="$t('No records available')"
        class="position-relative"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner
              class="align-middle"
              variant="primary"
            />
          </div>
        </template>
        <template #cell(SN)="data">
          {{ getTableNumber(data.index) }}
        </template>
        <template #cell(select)="data">
          <b-form-group class="mt-2">
            <b-form-radio
              v-model="data.item.select"
              :name="`radio-${data.index}`"
              value="Selected"
              @change="resetRadioButton(data.index)"
            />
          </b-form-group>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <!-- Dropdown -->
            <Button
              :label="$t('Select')"
              size="sm"
              :disabled="!data.item.select"
              @click="onSelectCard(data.item)"
            />
          </div>
        </template>

      </b-table>

      <TablePagination
        v-model="cardCurrentPage"
        :from="cardFrom"
        :to="cardTo"
        :total-rows="cardTotalEntries"
        :per-page="cardPerPage"
      />
      <div
        v-if="!isAssignedCard"
        class="text-center mt-1"
      >
        <Button
          :label="$t('Issue Card')"
          variant="primary"
          size="lg"
          class="mt-3"
          :loading="isLoading"
          :disabled="isDisabled"
          @click="handleSubmit"
        />
      </div>
      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="avatar-modal"
      ref="avatarModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="avatarModalTitle"
      @hidden="resetAvatarModal"
      @cancel="resetAvatarModal"
    >

      <div class="m-2 text-center">
        <b-row>
          <b-col cols="12">
            <b-avatar
              size="30rem"
              :src="avatarLg"
            />
          </b-col>
        </b-row>
      </div>

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />

  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BBadge, BFormGroup, BFormRadio, BFormCheckbox, BMedia,
  BModal, BForm, BAvatar,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, maxValue, positive } from '@validations'
import { heightFade } from '@core/directives/animations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions } from 'vuex'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import { toBalance } from '@/helpers/formatAmount'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import getStatusColor from '@/helpers/getStatusColor'
import Button from '../../../../components/button/Button.vue'
import Alert from '../../../../components/alert/Alert.vue'
import { eChannelsPermission } from '@/helpers/permissions'
import { cardRequestTypeOptions } from '@/helpers/data'

export default {
  components: {
    BCard,
    BRow,
    BBadge,
    BCol,
    Button,
    BTable,
    BModal,
    BMedia,
    Alert,
    BForm,
    BFormGroup,
    BAvatar,
    BFormRadio,
    BFormCheckbox,
    ValidationObserver,
    // SwitchButton,
    InputField,
    SelectField,
    TablePagination,
    TableEntries,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert],
  data() {
    return {
      cardRequestTypeOptions,
      isAssignedCard: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isLoading: false,
      isDisabled: true,
      isReadonly: false,
      isDisabledViewList: true,
      isDisabledIssuedCard: true,
      maxValue,
      positive,
      sortBy: 'accountName',
      avatarLg: '',
      avatarModalTitle: '',
      showFormErrorAlert: false,
      showSpinner: false,
      showTable: false,
      required,
      sortDesc: false,
      actionType: 'add',
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountType', sortable: true, label: 'Account Type' },
        { key: 'accountStatus', sortable: true, label: 'Account Status' },
      ],
      tableHeadersAssigned: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'batchNumber', sortable: true, label: 'Batch Number' },
        { key: 'maskedPAN', sortable: true, label: 'Masked PAN' },
        { key: 'cardStatus', sortable: true, label: 'Card Status' },
        { key: 'actions', label: 'Actions' },
      ],
      signatoryListHeader: [
        { key: 'SN', label: 'S/N' },
        { key: 'select', label: 'Select' },
        { key: 'fullName', sortable: true, label: 'Full Name' },
        { key: 'category', sortable: true, label: 'Category' },
        { key: 'passport', sortable: true, label: 'Passport' },
        { key: 'signature', sortable: true, label: 'Signature' },
      ],
      viewCardListHeader: [
        { key: 'SN', label: 'S/N' },
        { key: 'select', label: 'Select' },
        { key: 'maskedPan', sortable: true, label: 'Masked PAN' },
        { key: 'cardType', sortable: true, label: 'Card Type' },
        { key: 'actions', label: 'Actions' },
      ],
      viewCardLists: [],
      searchParams: {
        accountNumber: '',
        requestType: '',
      },
      signatoryList: [],
      selectedSignatories: [],
      issueCardFormData: {
        accountNumber: '',
        accountName: '',
        productName: '',
        availableBalance: '',
        cardId: '',
        cardGenerationRequestId: '',
      },
      maturityDate: null,
      getStatusColor,
      batchRequestOptions: [],
      filteredResult: [],
      customerList: [],

      cardTotalCount: 0,
      cardCurrentPage: 1,
      cardPerPage: 10,
    }
  },
  computed: {
    cardTotalEntries() {
      return this.cardTotalCount
    },
    cardFrom() {
      return (this.cardCurrentPage * this.cardPerPage) - (this.cardPerPage - 1)
    },
    cardTo() {
      return Math.min(this.cardFrom + this.cardPerPage - 1, this.cardTotalEntries)
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedSignatoryListHeader() {
      return this.signatoryListHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedViewCardListHeader() {
      return this.viewCardListHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedTableHeadersAssigned() {
      return this.tableHeadersAssigned.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedCardRequestTypeOptions() {
      return cardRequestTypeOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  mounted() {
    const { type } = this.$route.params
    this.actionType = type
    this.fetchBatchRequest()
    this.goToCardAccountDetails()
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      searchCustomerAccountToIssue: 'eChannels/searchCustomerAccountToIssue',

      getUserBalance: 'account/getCASABalanceAction',
      getAccountSignatories: 'account/getAccountSignatoriesAction',
      getByAccountNumber: 'account/getByAccountNumber',

      getBatchRequest: 'eChannels/getListBatchRequests',
      getAvailableCards: 'eChannels/getAvailableCardLists',
      createUnAssignedCards: 'eChannels/createUnAssignedCardsAction',
      createAssignedCards: 'eChannels/createAssignedCardsAction',
    }),
    getTableNumber(index) {
      return (this.cardCurrentPage * this.cardPerPage) - this.cardPerPage + index + 1
    },
    setCardRequestType(selectedValue) {
      if (selectedValue === 'AssignedCards') {
        this.isAssignedCard = true
      } else {
        this.isAssignedCard = false
      }
    },
    resetRadioButton(index) {
      const nextIndex = (this.cardCurrentPage * this.cardPerPage) - this.cardPerPage + index + 1
      const selectedIndex = nextIndex - 1
      this.viewCardLists = this.viewCardLists.map(item => ({
        ...item,
        select: '',
      }))
      this.viewCardLists.push(this.viewCardLists[selectedIndex].select = 'Selected')
      this.viewCardLists.pop()
    },
    onSelectCard(item) {
      this.isDisabled = false
      this.issueCardFormData.cardId = item.id
      this.alertSuccess({ text: this.$t('Card seleted') })
    },
    async fetchBatchRequest() {
      try {
        const response = await this.getBatchRequest({
          requestType: 'Unassigned',
          permission: eChannelsPermission.VIEW_ISSUED_CARDS,
        })
        const { status, data } = await response
        if (status === 200 && data.data) {
          this.batchRequestOptions = data.data.filter(items => items.generationStatus === 'Processed').map(item => ({ label: item.batchNo, value: item.id }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchCardLists() {
      try {
        const response = await this.getAvailableCards({
          cardGenerationRequestId: this.issueCardFormData.cardGenerationRequestId,
          issuanceStatus: 'NotIssued',
          status: 'Generated',
          permission: eChannelsPermission.VIEW_ISSUED_CARDS,
        })
        const { status, data } = await response
        if (status === 200 && data.data) {
          this.viewCardLists = data.data
          this.cardTotalCount = data.recordCount
          this.$root.$emit('bv::show::modal', 'unassigned-view-list-modal')
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    setBatchRequestId(batchId) {
      this.issueCardFormData.batchRequestId = batchId
    },
    onSelect(value) {
      if (value) {
        this.isDisabledViewList = false
        this.isDisabledIssuedCard = false
        this.selectedSignatories.push(value)
      } else {
        this.isDisabledViewList = true
        this.isDisabledIssuedCard = true
        this.selectedSignatories.pop()
      }
    },
    onViewPassportAndSignature() {
      this.$root.$emit('bv::show::modal', 'signatory-mandate-table')
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    async fetchAccountSignatories({ accountNumber }) {
      try {
        const { status, data } = await this.getAccountSignatories({ accountNumber, permission: eChannelsPermission.VIEW_ISSUED_CARDS })

        if (status === 200 && data.data) {
          this.signatoryList = data.data.map(item => ({
            fullName: item.name,
            passport: item.passportFileUrl,
            signature: item.signatureFileUrl,
            category: item.category,
            select: false,
          }))
        } else {
          this.signatoryList = []
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async issueCardAction() {
      const actionType = this.isAssignedCard ? this.$t('Assigned') : this.$t('Unassigned')
      try {
        this.isLoading = true
        const permission = eChannelsPermission.VIEW_ISSUED_CARDS
        const formData = {
          accountNumber: this.issueCardFormData.accountNumber,
          cardId: this.issueCardFormData.cardId,
        }
        const assignedFormData = {
          cardId: this.issueCardFormData.cardId,
        }
        const response = this.isAssignedCard === true
          ? await this.createAssignedCards({ assignedFormData, permission })
          : await this.createUnAssignedCards({ formData, permission })

        const { status } = await response
        if (status === 200) {
          this.$router.push({ name: 'issue-card-list' })
          this.hideModal('modal-lg')
          const requestText = this.$t('Your request to Issue')
          const actionText = this.$t('Card was successful')
          this.alertSuccess({ text: `${requestText} ${actionType} ${actionText}` })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to Issue')
          const reasonText = this.$t('Card failed. Reason')
          const errorMessage = `${requestText} ${actionType} ${reasonText}: ${responseError.errorMessage}`
          this.alertError({ text: errorMessage })
        })
      } finally {
        this.isLoading = false
      }
    },
    handleSubmit() {
      this.$refs.issueCardRules.validate().then(async success => {
        if (success) {
          this.confirm(this.issueCardAction, { text: this.$t('Are you sure you want to Issue this Cards?') })
        }
      })
    },
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          if (!this.isAssignedCard) {
            const { status, data } = await this.searchCustomerAccount({
              search: this.searchParams,
              page: this.currentPage,
              limit: this.perPage,
              permission: eChannelsPermission.VIEW_ISSUED_CARDS,
            })

            if (status === 200 && data?.data) {
              this.customerList = data.data
              this.totalCount = data.recordCount
              this.$root.$emit('bv::show::modal', 'search-modal')
            } else {
              this.customerList = []
              this.totalCount = data.recordCount
              this.$root.$emit('bv::show::modal', 'search-modal')
            }
          } else {
            const { status, data } = await this.searchCustomerAccountToIssue({
              search: this.searchParams,
              page: this.currentPage,
              limit: this.perPage,
              permission: eChannelsPermission.VIEW_ISSUED_CARDS,
            })

            if (status === 200 && data?.data) {
              this.customerList = data.data
              this.totalCount = data.recordCount
              this.$root.$emit('bv::show::modal', 'search-modal-assigned')
            } else {
              this.customerList = []
              this.totalCount = data.recordCount
              this.$root.$emit('bv::show::modal', 'search-modal-assigned')
            }
          }
        } else {
          this.showFormErrorAlert = true
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    async onSelectCustomer(items) {
      try {
        const [issueCardFormData] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        const { data, status } = await this.getUserBalance({ accountNumber: issueCardFormData?.accountNumber, permission: eChannelsPermission.VIEW_ISSUED_CARDS })
        if (status === 200) {
          this.issueCardFormData = {
            accountNumber: data.accountNumber,
            accountName: data.accountName,
            productName: data.productName,
            availableBalance: toBalance(data.availableBalance),
          }

          this.showCustomerInfo = true
          this.showSearchButton = true
          this.showBackButton = true
          await this.fetchAccountSignatories({ accountNumber: data.accountNumber })
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async onSelectCustomerAssigned(items) {
      try {
        this.hideModal('search-modal-assigned')
        this.showSpinner = true
        this.issueCardFormData = {
          batchRequestId: items.batchNumber,
          accountNumber: items.accountNumber,
          accountName: items.accountName,
          productName: items.productName,
          availableBalance: toBalance(items.availableBalance),
          cardId: items.cardId,
        }
        this.showCustomerInfo = true
        this.showSearchButton = true
        this.showBackButton = true
        await this.fetchAccountSignatories({ accountNumber: items.accountNumber })
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    onViewPassport(image, name) {
      this.avatarLg = image
      const passportText = this.$t('Passport')
      this.avatarModalTitle = `${name}'s ${passportText}`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    onViewSignature(image, name) {
      this.avatarLg = image
      const signatureText = this.$t('Signature')
      this.avatarModalTitle = `${name}'s ${signatureText}`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    resetAvatarModal() {
      this.avatarLg = ''
      this.avatarModalTitle = ''
    },
    resetIssueCardFormData() {
      this.issueCardFormData = { ...null }
    },
    resetSearchParams() {
      this.searchParams = { ...null }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'issue-card-list',
      })
    },
    async goToCardAccountDetails() {
      try {
        const { item, type } = this.$route.params
        if (item !== undefined) {
          if (item.issueCardStatus === 'Assigned') {
            this.isAssignedCard = true
          } else {
            this.isAssignedCard = false
          }

          this.showSearchButton = true
          this.showSpinner = true
          this.showCustomerInfo = true
          this.showBackButton = true
          this.actionType = type
          this.isDisabled = type !== 'edit'
          this.isEditable = true
          this.isReadonly = type !== 'edit'

          this.issueCardFormData = {
            accountName: item.accountName,
            accountNumber: item.accountNumber,
            productName: item.productName,
            availableBalance: toBalance(item.availableBalance),
            // batchRequestList: item.batchRequestId,
            batchRequestId: item.batchRequestId,
            cardSerialNumber: item.cardSerialNumber,
            cardId: item.cardId,
            waiveCardCost: item.waiveCardCost,
            cardGenerationRequestId: item.cardGenerationRequestId,
          }
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
  },
}
</script>
  <style scoped>
  .card-item {
    border: 1px solid #d8d6de !important;
    border-radius: 0.358rem
  }
  </style>
